import React, { useState } from 'react';
import { Globe } from 'lucide-react';
export function LanguageToggle() {
  const [lang, setLang] = useState<'es' | 'en'>('es');
  return <button onClick={() => setLang(lang === 'es' ? 'en' : 'es')} className="flex items-center gap-2 text-sm font-medium text-white/90 hover:text-white transition-colors" aria-label="Toggle language" data-id="element-135">
      <Globe className="h-4 w-4" data-id="element-136" />
      <span data-id="element-137">{lang === 'es' ? 'Español' : 'English'}</span>
    </button>;
}